// Safe Reach — crisis & support resources. US-focused with international options.

export const SAFE_REACH_RESOURCES = [
  {
    id: "sr_988",
    name: "988 Suicide & Crisis Lifeline",
    description:
      "Free, confidential 24/7 support for people in suicidal crisis or emotional distress.",
    tags: ["crisis", "suicide", "24/7"],
    actions: [
      { type: "call", label: "Call 988", value: "988" },
      { type: "sms", label: "Text 988", value: "988" },
      { type: "link", label: "Visit site", value: "https://988lifeline.org" },
    ],
  },
  {
    id: "sr_samhsa",
    name: "SAMHSA National Helpline",
    description:
      "Treatment referral and information for mental health and substance use — 24/7, free, confidential.",
    tags: ["substance use", "mental health", "24/7"],
    actions: [
      { type: "call", label: "Call 1-800-662-4357", value: "18006624357" },
      {
        type: "link",
        label: "Find treatment",
        value: "https://findtreatment.gov",
      },
    ],
  },
  {
    id: "sr_crisis_text",
    name: "Crisis Text Line",
    description:
      "Free, confidential 24/7 text support. Short codes differ by country.",
    tags: ["text", "crisis", "24/7"],
    actions: [
      { type: "sms", label: "US: Text HOME to 741741", value: "741741" },
      {
        type: "link",
        label: "Canada / UK / Ireland options",
        value: "https://www.crisistextline.org",
      },
    ],
  },
  {
    id: "sr_trevor",
    name: "The Trevor Project (LGBTQ+ Youth)",
    description:
      "24/7 crisis intervention and suicide prevention for LGBTQ+ young people under 25.",
    tags: ["LGBTQ+", "youth", "24/7"],
    actions: [
      { type: "call", label: "Call 1-866-488-7386", value: "18664887386" },
      { type: "sms", label: "Text START to 678678", value: "678678" },
      {
        type: "link",
        label: "Chat online",
        value: "https://www.thetrevorproject.org/get-help/",
      },
    ],
  },
  {
    id: "sr_dv",
    name: "National Domestic Violence Hotline",
    description:
      "Confidential support for anyone affected by relationship abuse — 24/7.",
    tags: ["DV", "abuse", "24/7"],
    actions: [
      { type: "call", label: "Call 1-800-799-7233", value: "18007997233" },
      { type: "sms", label: "Text START to 88788", value: "88788" },
      { type: "link", label: "Visit site", value: "https://www.thehotline.org" },
    ],
  },
  {
    id: "sr_rainn",
    name: "RAINN — Sexual Assault Hotline",
    description:
      "Confidential support for survivors of sexual violence, 24/7.",
    tags: ["sexual assault", "24/7"],
    actions: [
      { type: "call", label: "Call 1-800-656-4673", value: "18006564673" },
      { type: "sms", label: "Text HOPE to 64673", value: "64673" },
      { type: "link", label: "Online chat", value: "https://hotline.rainn.org" },
    ],
  },
  {
    id: "sr_intl",
    name: "International — Find a Helpline",
    description:
      "Search free, confidential helplines in 130+ countries.",
    tags: ["international"],
    actions: [
      { type: "link", label: "Find local help", value: "https://findahelpline.com" },
    ],
  },
];

export const SAFETY_TIPS = [
  "If you are in immediate danger, call your local emergency number (911 in the US).",
  "Reaching out can be one way to add support and reduce harm.",
  "You can leave this page at any time using the Exit button.",
];
